//import mediumZoom from 'medium-zoom';
// import { imagesReady } from "./helpers";
// const imagesLoaded = require('imagesloaded');
//import "zoom-vanilla.js/dist/zoom-vanilla.min.js"

import mediumZoom from 'medium-zoom';


export default class Gallery {
    constructor(target) {

        var zoom = mediumZoom(
            document.querySelectorAll('.js-gallery-image'), {
                margin: 0,
            }
        )
    }


}